<!-- components/Cards/OverviewCards/MonthlyOverviewCard.vue -->
<template>
    <Card title="Monthly Overview" class="monthly-overview-card">
      <div class="flex flex-col h-full">
        <div class="ai-insight">
          <div class="flex items-start">
            <div class="mr-2 mt-1">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-indigo-500" viewBox="0 0 20 20" fill="currentColor">
                <!-- SVG path here -->
              </svg>
            </div>
            <div>
              <p class="text-gray-700">
                Last month's data backups peaked higher but this is likely due to the recent rise in deployments and some deployments increasing alert counts, which could be from big changes in the back end.
              </p>
            </div>
          </div>
        </div>
        <div class="text-xs text-gray-500 mt-2">
          AI-generated insight • April 14, 2025
        </div>
      </div>
    </Card>
  </template>

<script>
import Card from '../Card.vue'

export default {
  name: 'MonthlyOverviewCard',
  components: {
    Card
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cards/AICards/MonthlyOverviewCard.vue